<template>
  <AppLink
    :to="url"
    class="item flex cursor-pointer select-none items-center transition-all duration-150 hover:bg-[--v3-theme-primarydarkestcolor]"
    :class="{
      'h-[41px] max-w-[277px] border-l-4 border-l-[--v3-theme-primarydarkestcolor] pl-[46px]': !props.flyout,
      'w-full rounded-[4px] p-[8px]': props.flyout,
      'bg-[--v3-theme-primarydarkcolor] text-[--v3-theme-primarytextcolor] hover:text-[--v3-theme-primarytextcolor]': !props.active && !props.flyout,
      'bg-[--v3-theme-primarycolor] text-[--v3-theme-primarytextcolor] hover:text-[--v3-theme-primarytextcolor]': !props.active && props.flyout,
      'bg-[--v3-theme-primarydarkercolor] text-[--v3-theme-primarytextcolor]': props.active,
    }"
  >
    <span
      class="item-name whitespace-nowrap transition-[opacity,font-size]"
      :class="{
        'text-[14px] opacity-100': !props.collapsed || props.flyout,
        'text-[0px] opacity-0': props.collapsed && !props.flyout,
        'font-bold': props.active,
      }"
    >
      {{ name }}
    </span>
  </AppLink>
</template>

<script lang="ts" setup>
import { computed, inject, onMounted } from 'vue';

import AppLink from '@/common/components/atoms/AppLink';
import { MenuGroupItemsCounterFn } from '@/modules/layout/types/keys';

const props = withDefaults(defineProps<{
  legacyUrl?: string | null | undefined,
  to?: string | null | undefined
  name: string,
  active?: boolean,
  collapsed?: boolean,
  flyout?: boolean,
}>(), {
  active: false,
  collapsed: false,
  flyout: false,
  legacyUrl: null,
  to: null,
});

const url = computed(() => props.to || props.legacyUrl);

const IncreaseMenuGroupItemsCounter = inject(MenuGroupItemsCounterFn);

onMounted(() => {
  IncreaseMenuGroupItemsCounter();
});
</script>
